var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-file-input', {
    attrs: {
      "label": _vm.label,
      "dense": "",
      "outlined": "",
      "persistent-placeholder": "",
      "messages": "첨부버튼을 누르셔야 정상 등록됩니다."
    },
    model: {
      value: _vm.temp,
      callback: function callback($$v) {
        _vm.temp = $$v;
      },
      expression: "temp"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "py-5",
    attrs: {
      "block": "",
      "color": "secondary",
      "elevation": "0"
    },
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("첨부")])], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-chip-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.value, function (file, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "rounded",
      attrs: {
        "value": file,
        "outlined": "",
        "color": "primary"
      }
    }, [_c('span', [_vm._v(_vm._s(file.name))]), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-close")])], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }